import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';

import { ISelectOption } from '../../../../../shared/form/element/base-select/select-option.interface';
import { AbstractPresetFormComponent } from '../../../../../shared/crud/component/preset-form.component';
import { CampaignId } from '../../../../campaign-util/shared/campaign-id';
import { EventBus } from '../../../../../shared/event/bus';
import { TemplateForm } from './template.form';
import { Language } from '../../../../../shared/enum/language';
import { MailType } from '../../../../mailing/shared/enum/mail-type';
import { AdminUrlBuilder } from '../../../../../shared/admin/api/admin-url-builder';
import { Subscription } from 'rxjs';
import { ErrorCodes } from '../../../../../shared/enum/api-errors';

@Component({
  selector: 'admin-mail-template-form',
  templateUrl: './form.component.html',
  styleUrls: [ './form.component.scss' ]
})
export class AdminMailTemplateFormComponent extends AbstractPresetFormComponent implements AfterViewInit, OnChanges {

  email: string;
  templateVar: string;
  activeTab: string = 'editor';

  languages: any[] = Object.keys(Language).map((lang: string) => {
    return {
      value: lang,
      label: Language[lang]
    };
  });
  protected sendPromise: Subscription;

  @Input() type: string;
  @Input() row: any;
  @Input() selectedRowId: number;
  @Input() vars: ISelectOption[] = [];
  @Output() makeDefault = new EventEmitter();
  @Output() delete = new EventEmitter();
  isEditMode: boolean = false;

  @ViewChild('formModal', { static: false }) formModal: ModalDirective;

  types: ISelectOption[] = Object.keys(MailType).filter((t: any) => !t.forAdmin).map((type: string) => {
    return {
      value: type,
      label: MailType[type].name
    };
  });

  constructor(formBuilder: TemplateForm,
              httpClient: HttpClient,
              toastrService: ToastrService,
              urlBuilder: AdminUrlBuilder,
              router: Router,
              route: ActivatedRoute,
              campaignId: CampaignId,
              eventBus: EventBus) {
    super(formBuilder, httpClient, toastrService, urlBuilder, router, route, campaignId, eventBus);
  }

  ngOnInit() {
    super.ngOnInit();

    this.record = this.row;

    this.form.controls.type.patchValue(this.type);
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngAfterViewInit() {
    if (this.row.id) {
      this.formMode = 'update';
      this.form.reset(this.row);
    } else {
      this.formMode = 'create';
    }
  }

  protected getUrl(forceId?: number): string {
    const params = this.route.snapshot.params;
    return '/template' + (params.id ? `/${params.id}` : forceId ? `/${forceId}` : '');
  }

  protected onSubmit(response: any): void {
    super.onSubmit(response);
    this.editRow();
  }

  load(id: number) {
    this.loading = true;
    let url = this.getUrl(id);
    if (this.urlBuilder) {
      url = this.urlBuilder.buildUrl(url);
    }
    this.httpClient.get<any>(url)
      .subscribe(
        (data: any) => {
          this.row = data;
          this.form.patchValue(this.row);
          this.loading = false;
        },
        (error: any) => {
          this.toastrService.error(error.error ? (error.error.message || ErrorCodes[error.error.code] || 'Something went wrong...') : 'Error');
          this.loading = false;
        }
      );
  }

  editRow() {
    this.isEditMode = !this.isEditMode;
    this.load(this.row.id);
  }

  toggleTab(tabName: string): void {
    this.activeTab = tabName;
  }

  insertVariable(): void {
    const el: any = document.getElementsByName('content')[0];
    const value = this.form.controls['content'].value;
    const begin = value.slice(0, el.selectionStart);
    const end = value.slice(el.selectionStart, value.length);

    this.form.controls['content'].setValue(begin + '*|' + this.templateVar + '|*' + end);
  }

  send() {
    this.sendPromise = this.httpClient.post(this.urlBuilder.buildUrl(`/template/${this.row.id}/send`), { email: this.email })
      .subscribe((response: any) => {
        this.toastrService.success('Sent');
      }, (error: any) => {
        this.toastrService.error('Coud not send template');
      });
  }
}
